export default __webpack_public_path__ + "static/media/main-category-photography-film.b333c06c.jpg";